var map = {
	"./AntMall/logo.svg": "2fe2",
	"./Argos/logo.svg": "ef60",
	"./ArgosShop/logo.svg": "021c",
	"./EShop/logo.svg": "54a7",
	"./FamilyMart/logo.svg": "5d5b",
	"./FamilyShop/logo.svg": "8bb8",
	"./Green Mall/logo.svg": "fc67",
	"./Hive/logo.svg": "1707",
	"./INT Overstock/logo.svg": "4c97",
	"./Iceland/logo.svg": "8b33",
	"./Inchoi/logo.svg": "acc6",
	"./Just Shop/logo.svg": "8dbd",
	"./Laz/logo.svg": "dc79",
	"./Mbuy/logo.svg": "6abb",
	"./MetaShop/logo.svg": "66af",
	"./SM-wholesale shop/logo.svg": "c502",
	"./Shop2u/logo.svg": "0f32",
	"./Shopee/logo.svg": "e4fb",
	"./Shopify/logo.svg": "5610",
	"./TikTok-Wholesale/logo.svg": "972b",
	"./Tongda/logo.svg": "098b"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "4621";